import { z } from 'zod'

export const DeleteLineItemSchema = z.object({
    cart_id: z.string().min(1),
    line_id: z.string(),
})
